<template>
    <div>
        <div v-if="listByDate.today.length > 0">
            <div class="uk-padding-small uk-padding-remove-left uk-padding-remove-right uk-text-bold">
                Today
            </div>
            <opportunity-list
                :opportunities="listByDate.today"
                :section-name="sectionName"
                :is-quick-filter-result="isQuickFilterResult"
                :is-refund-request-date-filter-result="isRefundRequestDateFilterResult"
                :open-panel-by-default="openPanelByDefault"
                @setPage="setPage"
                @verifyAll="verifyAll"
                @approveAll="approveAll"
                @rejectAll="rejectAll"
                @cancelAll="cancelAll"
            />
        </div>

        <div v-if="listByDate.yesterday.length > 0">
            <div class="uk-padding-small uk-padding-remove-left uk-padding-remove-right uk-text-bold">
                Yesterday
            </div>
            <opportunity-list
                :opportunities="listByDate.yesterday"
                :section-name="sectionName"
                :is-quick-filter-result="isQuickFilterResult"
                :is-refund-request-date-filter-result="isRefundRequestDateFilterResult"
                :open-panel-by-default="openPanelByDefault"
                @setPage="setPage"
                @verifyAll="verifyAll"
                @approveAll="approveAll"
                @rejectAll="rejectAll"
                @cancelAll="cancelAll"
            />
        </div>

        <div v-if="listByDate.older.length > 0">
            <div class="uk-padding-small uk-padding-remove-left uk-padding-remove-right uk-text-bold">
                Older
            </div>
            <opportunity-list
                :opportunities="listByDate.older"
                :section-name="sectionName"
                :is-quick-filter-result="isQuickFilterResult"
                :is-refund-request-date-filter-result="isRefundRequestDateFilterResult"
                :open-panel-by-default="openPanelByDefault"
                @setPage="setPage"
                @verifyAll="verifyAll"
                @approveAll="approveAll"
                @rejectAll="rejectAll"
                @cancelAll="cancelAll"
            />
        </div>

        <div class="uk-flex uk-flex-middle uk-flex-right uk-margin-top">
            <pagination
                :pagination="pagination"
                @setPage="setPage"
            />
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';

const OpportunityList = () => import("./OpportunityList");
const Pagination = () => import("@strangeanimals/common-vue-components/src/components/list/Pagination");

export default {
    name: 'OpportunityListByDate',
    components: { Pagination, OpportunityList },
    props: {
        opportunities: {
            type: Array,
            default: function () {
                return [];
            }
        },
        pagination: {
            type: Object,
            default: function () {
                return {}
            }
        },
        sectionName: {
            type: String,
            required: true
        },
        isQuickFilterResult: {
            type: String,
            default: ''
        },
        isRefundRequestDateFilterResult: {
            type: Boolean,
            default: false
        },
        openPanelByDefault: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({

        }),
        listByDate() {
            let list = {
                today: [],
                yesterday: [],
                older: []
            };

            let today = DateTime.local().toFormat('dd/LL/yyyy');
            let yesterday = DateTime.local().minus({days: 1}).toFormat('dd/LL/yyyy');

            for (let opp of this.opportunities) {
                let cancellationInitiatedDate = DateTime.fromISO(opp.cancellation_initiated_date).toLocal().toFormat('dd/LL/yyyy');
                if (cancellationInitiatedDate === today) {
                    list.today.push(opp);
                } else if (cancellationInitiatedDate === yesterday) {
                    list.yesterday.push(opp);
                } else {
                    list.older.push(opp);
                }
            }

            return list;
        },
    },
    methods: {
        setPage(page) {
            this.$emit('setPage', page);
        },
        approveAll(tokens) {
            return this.$emit('approveAll', tokens);
        },
        verifyAll(tokens) {
            return this.$emit('verifyAll', tokens);
        },
        cancelAll(tokens) {
            return this.$emit('cancelAll', tokens);
        },
        rejectAll(tokens) {
            return this.$emit('rejectAll', tokens);
        },
    }
}
</script>
